import { HomeButton } from 'app/agriculture/components/Tools/components/HomeButton/HomeButton';
import { ZoomButtons } from 'app/agriculture/components/Tools/components/ZoomButtons/ZoomButtons';
import { ScaleIndicator } from 'app/agriculture/AgricultureMap/components/ScaleIndicator/ScaleIndicator';
import './ToolStack.scss';

export function ToolStack() {
    return (
        <div className="ToolStack" data-testid="ToolStack">
            <ScaleIndicator />
            <div className="ToolStack__buttons">
                <ZoomButtons />
                <HomeButton />
            </div>
        </div>
    );
}
